export default __webpack_public_path__ + "static/RightPhone4X-62c6129d15209911667d2072456e2020.webp";